<template>
    <LayoutWithContainer>
        <div v-if="$wait.is('events')" class="loading">
            <Spinner :height="40" :width="40"/>
        </div>
        <template v-else>
            <template slot="header" v-if="events">
                <ContentHeader
                    title="Conferences Documents"
                    back-link="/documents"
                    back-link-title="Back to Documents"
                />
            </template>
            <ul class="grid grid--cards">
                <li class="grid__error col-12" v-if="error">
                    <span class="h2">Unable to load events.</span>
                    <button class="btn btn--link" @click.prevent="getEvents">Retry</button>
                </li>
                <template v-if="events.length">
                    <li v-for="event in events" class="col-md-6 col-lg-6 col-12">
                        <Card
                            :url="`/documents/conferences/${event.id}`"
                            :title="event.eventName"
                            :sub-title="event.start ? event.start.displayDate : null"
                            :img="event.backgroundImage ? event.backgroundImage : null"
                        />
                    </li>
                </template>
            </ul>
        </template>
    </LayoutWithContainer>
</template>

<script>
    import API from '@api';
    import LayoutList from '@layouts/LayoutList';
    import LayoutWithContainer from '@layouts/LayoutWithContainer';
    import ContentHeader from '@components/Header/ContentHeader';
    import Card from '@components/Card/Card';
    import Spinner from '@components/Spinner';

    export default {
        name: "ConferencesRoot",
        components: {
            LayoutWithContainer,
            LayoutList,
            ContentHeader,
            Card,
            Spinner
        },
        data() {
            return {
                events: [],
                error: false,
            }
        },
        created() {
            this.getEvents();
        },
        methods: {
            async getEvents() {
                this.error = false;
                this.$wait.start('events');

                try {
                    this.events = await API.getEvents({'per_page': 100, 'sort': "name|asc"});
                } catch(err) {
                    console.warn(err);
                    this.events = []
                    this.error = true;
                } finally {
                    this.$wait.end('events')
                }
            },
        },
    }
</script>
<style lang="scss">
    .loading {
        min-height: 20rem;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        gap: 1rem;
    }
</style>
